/* KG Relaunch V2: Schnellauswahl (Bottom-Sheet) fuer Upsells und Warenkorb, 28.09.2026.
   Oeffnen: Klick auf [data-kg2-qa="<handle>"] oder window.kg2QuickAdd.open(handle, {preset, trigger}).
   Produkte mit nur einer Variante werden direkt eingelegt. Groesse wird nie vorausgewaehlt,
   ausser sie kommt als preset. Einlegen per /cart/add.js mit sections, danach rendert der
   Cart-Drawer neu wie in Dawn 16 (renderContents). */
(function () {
  if (window.kg2QuickAdd) return;

  var FARBEN = {
    'schwarz': '#151515', 'weiß': '#fafafa', 'weiss': '#fafafa', 'beige': '#d8c6a6', 'burgunder': '#6b1f2b',
    'grün': '#2e5b39', 'gruen': '#2e5b39', 'navy': '#1e2a45', 'grau': '#8a8d88', 'heather grey': '#a7a9a6',
    'rot': '#b3261e', 'blau': '#2c4f8a', 'hellblau': '#9dbcd4', 'khaki': '#7b7a52', 'oliv': '#5b6138',
    'sand': '#d9c9a8', 'braun': '#6b4a33', 'rosa': '#e8b7c0', 'lila': '#6f4a8e', 'gelb': '#e8c547', 'creme': '#f3ead7'
  };
  if (window.kg2FarbWerte) { Object.keys(window.kg2FarbWerte).forEach(function (k) { FARBEN[k] = window.kg2FarbWerte[k]; }); }
  var root, sheet, state = null, lastTrigger = null;

  function geld(c) {
    try { return (c / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); }
    catch (e) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function istFarbe(n) { return /^farbe/i.test(n); }
  function istGroesse(n) { return /^gr(ö|oe)(ß|ss)e/i.test(n); }
  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }

  function bauen() {
    if (root) return;
    root = el('div', 'kg2qa'); root.hidden = true;
    root.innerHTML = '<div class="kg2qa__sheet" role="dialog" aria-modal="true" aria-labelledby="Kg2QaTitel" tabindex="-1">' +
      '<button type="button" class="kg2qa__zu" aria-label="Schließen">&times;</button>' +
      '<div class="kg2qa__kopf"><img class="kg2qa__bild" alt="" width="90" height="90"><div><p class="kg2qa__titel" id="Kg2QaTitel"></p><p class="kg2qa__preis"></p></div></div>' +
      '<div class="kg2qa__opts"></div><p class="kg2qa__hinweis" role="status" aria-live="polite"></p>' +
      '<button type="button" class="kg2qa__add" disabled>Größe wählen</button></div>';
    document.body.appendChild(root);
    sheet = root.querySelector('.kg2qa__sheet');
    root.addEventListener('click', function (e) {
      if (e.target === root || e.target.closest('.kg2qa__zu')) { zu(); return; }
      var w = e.target.closest('.kg2qa__w');
      if (w && !w.disabled) { waehle(+w.dataset.i, w.dataset.v); return; }
      if (e.target.closest('.kg2qa__add')) einlegen();
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); zu(); return; }
      if (e.key !== 'Tab') return;
      var f = [].slice.call(sheet.querySelectorAll('button:not([disabled]), a[href]'));
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    });
  }

  function variante() {
    var p = state.p;
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i], ok = true;
      for (var k = 0; k < p.options.length; k++) { if (v.options[k] !== state.sel[k]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }
  function moeglich(k, wert) {
    /* gibt es eine verfuegbare Variante mit diesem Wert und den uebrigen bisher gewaehlten Werten? */
    return state.p.variants.some(function (v) {
      if (!v.available || v.options[k] !== wert) return false;
      for (var j = 0; j < state.p.options.length; j++) {
        if (j !== k && state.sel[j] != null && v.options[j] !== state.sel[j]) return false;
      }
      return true;
    });
  }

  function zeichnen() {
    var p = state.p, box = root.querySelector('.kg2qa__opts');
    box.innerHTML = '';
    p.options.forEach(function (o, k) {
      var name = o.name || o;
      var wrap = el('div', 'kg2qa__opt');
      var lab = el('p', 'kg2qa__label');
      var l1 = el('span'); l1.innerHTML = '';
      l1.appendChild(document.createTextNode(name + ': '));
      l1.appendChild(el('b', null, state.sel[k] || 'bitte wählen'));
      lab.appendChild(l1);
      if (istGroesse(name) && p.url) { var a = el('a', null, 'Größentabelle'); a.href = p.url + '#kg2-groesse'; lab.appendChild(a); }
      wrap.appendChild(lab);
      var werte = el('div', 'kg2qa__werte');
      werte.setAttribute('role', 'group'); werte.setAttribute('aria-label', name);
      o.values.forEach(function (wert) {
        var b = el('button', 'kg2qa__w');
        b.type = 'button'; b.dataset.i = k; b.dataset.v = wert;
        b.setAttribute('aria-pressed', state.sel[k] === wert ? 'true' : 'false');
        if (istFarbe(name)) {
          var hex = FARBEN[String(wert).toLowerCase()];
          if (hex) { b.className += ' kg2qa__w--farbe'; b.style.background = hex; b.style.setProperty('--sw', hex); b.title = wert; b.setAttribute('aria-label', wert); }
          else b.textContent = wert;
        } else b.textContent = wert;
        var geht = moeglich(k, wert);
        if (!geht) { b.disabled = true; b.setAttribute('aria-label', wert + ' (nicht verfügbar)'); }
        werte.appendChild(b);
      });
      wrap.appendChild(werte);
      box.appendChild(wrap);
    });
    var v = variante();
    var bild = root.querySelector('.kg2qa__bild');
    var src = (v && v.featured_image && v.featured_image.src) || state.bildFarbe() || p.featured_image;
    if (src) { bild.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=240'; bild.hidden = false; } else bild.hidden = true;
    var preis = v ? v.price : p.price, alt = v ? v.compare_at_price : p.compare_at_price;
    root.querySelector('.kg2qa__preis').innerHTML = state.gratis ? '<b>0,00 €</b><s>' + geld(preis) + '</s>' :
      (alt > preis ? '<s>' + geld(alt) + '</s> ' : '') + '<b>' + geld(preis) + '</b>' + (alt > preis ? '<span class="kg2qa__rabatt">−' + Math.round((alt - preis) * 100 / alt) + ' %</span>' : '');
    var add = root.querySelector('.kg2qa__add');
    var offen = p.options.map(function (o, k) { return state.sel[k] == null ? (o.name || o) : null; }).filter(Boolean);
    if (offen.length) { add.disabled = true; add.textContent = offen[0].replace(/^Größe/, 'Größe') + ' wählen'; }
    else if (!v || !v.available) { add.disabled = true; add.textContent = 'Nicht verfügbar'; }
    else { add.disabled = false; add.textContent = 'In den Warenkorb · ' + (state.gratis ? '0,00 €' : geld(v.price)); }
  }

  function waehle(k, wert) {
    state.sel[k] = wert;
    /* Wert, der mit der neuen Wahl nicht mehr geht, wieder freigeben */
    state.p.options.forEach(function (o, j) { if (j !== k && state.sel[j] != null && !moeglich(j, state.sel[j])) state.sel[j] = null; });
    root.querySelector('.kg2qa__hinweis').textContent = '';
    zeichnen();
    var b = root.querySelector('.kg2qa__w[data-i="' + k + '"][data-v="' + (window.CSS && CSS.escape ? CSS.escape(wert) : wert) + '"]');
    if (b) b.focus();
  }

  function drawer() { return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }

  function legeEin(id, btn, fertig) {
    var cart = drawer();
    var fd = new FormData();
    fd.append('id', id); fd.append('quantity', '1');
    if (cart && cart.getSectionsToRender) {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
    }
    if (btn) btn.setAttribute('aria-busy', 'true');
    return fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'Das hat nicht geklappt.');
        if (fertig) fertig();
        if (!cart) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return res; }
        if (window.publish && window.PUB_SUB_EVENTS) { try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kg2-quickadd', productVariantId: id, cartData: res }); } catch (x) {} }
        cart.classList.remove('is-empty');
        if (cart.renderContents) cart.renderContents(res);
        return res;
      })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }

  function einlegen() {
    var add = root.querySelector('.kg2qa__add');
    var v = variante();
    if (!v || add.disabled) {
      root.querySelector('.kg2qa__hinweis').textContent = 'Bitte zuerst eine Größe wählen.';
      return;
    }
    legeEin(v.id, add, function () { zu(true); })
      .catch(function (e) { root.querySelector('.kg2qa__hinweis').textContent = e.message; });
  }

  function auf() {
    root.hidden = false;
    document.documentElement.classList.add('kg2qa-offen');
    if (typeof window.removeTrapFocus === 'function') { try { removeTrapFocus(); } catch (e) {} }
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    var ziel = root.querySelector('.kg2qa__w:not(.kg2qa__w--farbe)[aria-pressed="false"]:not(:disabled)') || root.querySelector('.kg2qa__add:not(:disabled)') || root.querySelector('.kg2qa__zu');
    setTimeout(function () { (ziel || sheet).focus(); }, 30);
  }

  function zu(nachEinlegen) {
    if (!root || root.hidden) return;
    root.classList.remove('is-open');
    root.hidden = true;
    document.documentElement.classList.remove('kg2qa-offen');
    var d = document.querySelector('cart-drawer');
    if (!nachEinlegen && d && d.classList.contains('active') && typeof window.trapFocus === 'function') {
      var c = d.classList.contains('is-empty') ? d.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      try { trapFocus(c || d, lastTrigger && document.contains(lastTrigger) ? lastTrigger : undefined); } catch (e) {}
    } else if (!nachEinlegen && lastTrigger && document.contains(lastTrigger)) {
      lastTrigger.focus();
    }
  }

  function oeffnen(handle, opts) {
    opts = opts || {};
    lastTrigger = opts.trigger || document.activeElement;
    var t = opts.trigger;
    if (t) t.setAttribute('aria-busy', 'true');
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { if (!r.ok) throw new Error('produkt'); return r.json(); })
      .then(function (p) {
        if (t) t.removeAttribute('aria-busy');
        var echteOpt = p.options && p.options.length && !(p.variants.length === 1);
        if (!echteOpt) {
          var v0 = p.variants.filter(function (v) { return v.available; })[0];
          if (!v0) return;
          return legeEin(v0.id, t);
        }
        bauen();
        var preset = opts.preset || {};
        var sel = p.options.map(function (o) {
          var name = o.name || o, vals = o.values || [];
          var want = null;
          Object.keys(preset).forEach(function (pk) {
            if (preset[pk] == null) return;
            if (pk === name || (istGroesse(pk) && istGroesse(name)) || (istFarbe(pk) && istFarbe(name))) {
              if (vals.indexOf(preset[pk]) > -1) want = preset[pk];
            }
          });
          if (want == null && !istGroesse(name) && vals.length === 1) want = vals[0];
          return want;
        });
        state = { p: p, sel: sel, gratis: !!opts.gratis };
        /* Farbe: vorausgewaehlt die Farbe der Karte, sonst die erste verfuegbare */
        p.options.forEach(function (o, k) {
          if (istFarbe(o.name || o) && state.sel[k] == null) {
            var frei = (o.values || []).filter(function (w) { return moeglich(k, w); })[0];
            state.sel[k] = frei || null;
          }
        });
        /* nicht (mehr) moegliche Vorauswahl verwerfen */
        p.options.forEach(function (o, k) { if (state.sel[k] != null && !moeglich(k, state.sel[k])) state.sel[k] = null; });
        state.bildFarbe = function () {
          var fk = -1; p.options.forEach(function (o, k) { if (istFarbe(o.name || o)) fk = k; });
          if (fk < 0 || state.sel[fk] == null) return null;
          var v = p.variants.filter(function (x) { return x.options[fk] === state.sel[fk] && x.featured_image; })[0];
          return v ? v.featured_image.src : null;
        };
        root.querySelector('.kg2qa__titel').textContent = p.title;
        root.querySelector('.kg2qa__hinweis').textContent = '';
        zeichnen();
        auf();
      })
      .catch(function () { if (t) t.removeAttribute('aria-busy'); if (t && t.dataset.kg2QaUrl) window.location = t.dataset.kg2QaUrl; });
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-kg2-qa]') : null;
    if (!t || t.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    var preset = {};
    if (t.dataset.kg2QaFarbe) preset['Farbe'] = t.dataset.kg2QaFarbe;
    if (t.dataset.kg2QaGroesse) preset['Größe'] = t.dataset.kg2QaGroesse;
    oeffnen(t.dataset.kg2Qa, { preset: preset, trigger: t, gratis: t.dataset.kguGratis === '1' });
  });

  window.kg2QuickAdd = { open: oeffnen, close: zu, add: legeEin };
})();
